<template>
  <div class="expenses-navigation-wrapper d-none d-md-flex flex-wrap">
    <ib-button
      class="px-2 px-lg-3"
      variant="white"
      font-family="medium"
      :to="{name: 'financial-plan-expenses-startup-costs'}"
    >
      {{ $t('pages.businessGuide.navigation.startupCosts') }}
    </ib-button>
    <ib-button
      class="px-2 px-lg-3"
      variant="white"
      font-family="medium"
      :to="{name: 'financial-plan-expenses-payroll-expenses'}"
    >
      {{ $t('pages.businessGuide.navigation.staffAndPayroll') }}
    </ib-button>
    <ib-button
      class="px-2 px-lg-3"
      variant="white"
      font-family="medium"
      :to="subscriptionIsFreeTrial ? {} : {name: 'financial-plan-expenses-direct-costs'}"
      @click="onClick"
    >
      <template #icon-right>
        <i v-if="subscriptionIsFreeTrial" class="ib-icon ib-icon-lock-2 o-50" />
      </template>
      {{ $t('pages.businessGuide.navigation.directCosts') }}
    </ib-button>
    <ib-button
      class="px-2 px-lg-3"
      variant="white"
      font-family="medium"
      :to="subscriptionIsFreeTrial ? {} : {name: 'financial-plan-expenses-marketing-costs'}"
      @click="onClick"
    >
      <template #icon-right>
        <i v-if="subscriptionIsFreeTrial" class="ib-icon ib-icon-lock-2 o-50" />
      </template>
      {{ $t('pages.businessGuide.navigation.marketingBudget') }}
    </ib-button>
    <ib-button
      class="px-2 px-lg-3"
      variant="white"
      font-family="medium"
      :to="subscriptionIsFreeTrial ? {} : {name: 'financial-plan-expenses-other-overheads'}"
      @click="onClick"
    >
      <template #icon-right>
        <i v-if="subscriptionIsFreeTrial" class="ib-icon ib-icon-lock-2 o-50" />
      </template>
      {{ $t('pages.businessGuide.navigation.otherOverheads') }}
    </ib-button>
  </div>
</template>

<script>
import MixinUserSubscription from '@/mixins/permissions/userSubscription'
import { mapMutations } from 'vuex'

export default {
  name: 'ExpensesNavigation',

  mixins: [MixinUserSubscription],

  methods: {
    ...mapMutations('ui', ['setDialogUpgradeState']),

    onClick () {
      if (!this.subscriptionIsFreeTrial) return
      this.setDialogUpgradeState(true)
    }
  }
}
</script>

<style scoped lang="scss">
.expenses-navigation-wrapper {
  row-gap: 10px;
  column-gap: 10px;
}
</style>
